import { Bell } from "lucide-react-native";
import { IconButton } from "@louise/moon-ui";
import { EMBER } from "../../../onboarding/theme";

type Props = {
  hasUnread: boolean;
  onPress: () => void;
};

export default function NotificationBellButton({ hasUnread, onPress }: Props) {
  return (
    <IconButton
      onPress={onPress}
      hitSlop={8}
      size={36}
      testID="notification-bell"
      accessibilityLabel="Notifications"
      badge={hasUnread}
      badgeColor={EMBER.colors.warm}
      badgeSize={7}
      badgeTop={6}
      badgeRight={6}
    >
      <Bell size={22} color={EMBER.colors.textMid} strokeWidth={1.5} />
    </IconButton>
  );
}
